import React, { useEffect } from 'react';
import get from 'lodash/get';
import { useDispatch } from 'react-redux';
import { Page } from 'modules/ui';
import { useTealiumView } from 'modules/accounts';
import { ProducerTalentDetails } from '../components';
import { loadTalent } from '../redux';
import TalentPreviewHeader from './TalentPreviewHeader';
import { useParams } from 'react-router-dom';
import { ScrollingProvider } from 'modules/core';

export default function TalentPreviewPage() {
  const params = useParams();
  const dispatch = useDispatch();
  const talentId = get(params, 'talentId');

  useTealiumView('Talent Profile Page');

  useEffect(() => {
    dispatch(loadTalent(talentId));
  }, [dispatch, talentId]);

  return (
    <Page HeaderComponent={<TalentPreviewHeader talentId={talentId} />}>
      <ScrollingProvider />
      <ProducerTalentDetails talentId={talentId} />
    </Page>
  );
}
